// -----------------------------------------------------------
// FloraIQ - PointCloudStatusBadge — Badge para status de nuvem/levantamento
// -----------------------------------------------------------

const statusConfig: Record<string, { label: string; colorClass: string }> = {
  planejado: { label: "Planejado", colorClass: "bg-gray-100 text-gray-700 border-gray-200" },
  coletado: { label: "Coletado", colorClass: "bg-blue-50 text-blue-700 border-blue-200" },
  em_processamento: { label: "Em Processamento", colorClass: "bg-amber-50 text-amber-700 border-amber-200" },
  processado: { label: "Processado", colorClass: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  validado: { label: "Validado", colorClass: "bg-green-50 text-green-700 border-green-200" },
  com_inconsistencia: { label: "Com Inconsistência", colorClass: "bg-red-50 text-red-700 border-red-200" },
  arquivado: { label: "Arquivado", colorClass: "bg-slate-50 text-slate-600 border-slate-200" },
  disponivel: { label: "Disponível", colorClass: "bg-green-50 text-green-700 border-green-200" },
  processando: { label: "Processando", colorClass: "bg-amber-50 text-amber-700 border-amber-200" },
  pendente: { label: "Pendente", colorClass: "bg-orange-50 text-orange-700 border-orange-200" },
  resolvido: { label: "Resolvido", colorClass: "bg-green-50 text-green-700 border-green-200" },
  monitorando: { label: "Monitorando", colorClass: "bg-blue-50 text-blue-700 border-blue-200" },
  critico: { label: "Crítico", colorClass: "bg-red-100 text-red-800 border-red-300" },
  classificado: { label: "Classificado", colorClass: "bg-green-50 text-green-700 border-green-200" },
  sem_3d: { label: "Sem métrica 3D", colorClass: "bg-gray-100 text-gray-600 border-gray-200" },
  divergente: { label: "Divergente", colorClass: "bg-orange-50 text-orange-700 border-orange-200" },
};

const confidenceConfig: Record<string, { label: string; colorClass: string }> = {
  alta: { label: "Alta", colorClass: "bg-green-50 text-green-700 border-green-200" },
  media: { label: "Média", colorClass: "bg-amber-50 text-amber-700 border-amber-200" },
  baixa: { label: "Baixa", colorClass: "bg-red-50 text-red-700 border-red-200" },
  "-": { label: "-", colorClass: "bg-gray-50 text-gray-500 border-gray-200" },
};

interface ProcessingBadgeProps {
  status: string;
  className?: string;
}

export default function ProcessingBadge({ status, className = "" }: ProcessingBadgeProps) {
  const config = statusConfig[status] || { label: status, colorClass: "bg-gray-100 text-gray-600 border-gray-200" };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full border whitespace-nowrap ${config.colorClass} ${className}`}>
      {config.label}
    </span>
  );
}

interface ConfidenceBadgeProps {
  level: string;
  className?: string;
}

export function ConfidenceBadge({ level, className = "" }: ConfidenceBadgeProps) {
  const config = confidenceConfig[level] || { label: level, colorClass: "bg-gray-100 text-gray-600 border-gray-200" };
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full border whitespace-nowrap ${config.colorClass} ${className}`}>
      {level === "alta" && <i className="ri-checkbox-circle-fill text-[10px]"></i>}
      {level === "media" && <i className="ri-indeterminate-circle-fill text-[10px]"></i>}
      {level === "baixa" && <i className="ri-close-circle-fill text-[10px]"></i>}
      {config.label}
    </span>
  );
}

interface QualityBadgeProps {
  value: number;
  className?: string;
}

export function QualityBadge({ value, className = "" }: QualityBadgeProps) {
  let colorClass = "bg-green-50 text-green-700 border-green-200";
  if (value === 0) colorClass = "bg-gray-50 text-gray-500 border-gray-200";
  else if (value < 60) colorClass = "bg-red-50 text-red-700 border-red-200";
  else if (value < 80) colorClass = "bg-amber-50 text-amber-700 border-amber-200";
  else if (value < 90) colorClass = "bg-blue-50 text-blue-700 border-blue-200";

  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full border whitespace-nowrap ${colorClass} ${className}`}>
      {value > 0 ? `${value}%` : "-"}
    </span>
  );
}